module.exports = __webpack_public_path__ + "img/desk3.f67500b1.png";